// src/modals/RoleModal.js
import React from "react";

const PENDING_KEY = "medmaze_signup_role_pending";

function RoleModal({ open, onClose, onSelectRole }) {
  if (!open) return null;
  const close = () => {
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch {}
    onClose?.();
  };
  const pick = (role) => {
    try {
      localStorage.setItem(PENDING_KEY, role);
    } catch {}
    onSelectRole?.(role);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <button
          type="button"
          onClick={close}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-2 text-center">Continue as…</h2>
        <p className="text-sm text-gray-600 mb-6 text-center">
          Choose your account type.
        </p>

        <button
          type="button"
          onClick={() => pick("PATIENT")}
          //onClick={() => goRegisterWithRole("PATIENT")}
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 mb-3"
        >
          Patient
        </button>

        <button
          type="button"
          onClick={() => pick("PROVIDER")}
          //onClick={() => goRegisterWithRole("PROVIDER")}
          className="w-full border border-blue-500 text-blue-600 py-2 px-4 rounded hover:bg-blue-50"
        >
          Provider
        </button>
      </div>
    </div>
  );
}

export default RoleModal;
